import { getEditorString, getPointAfter, wrapNodes } from '@udecode/plate'
import type { Range } from 'slate'
import { withoutLosingSelection } from '~publish/legacy/editor/helpers/withoutLosingSelection'
import type { BufferEditor } from '../../../BufferEditor/types.plate'
import type { WithPosition } from '../../../helpers/WithPosition'
import { findCharacterLimitPoint } from '../../character-limit-highlight'
import {
  LinkedInAnnotationInputElement,
  type LinkedInAnnotationEntityDetails,
} from '../nodes/LinkedInAnnotationInputElement'

/**
 * Given an editor and a linkedin mention entity,
 * find its location in the editor and insert
 * a LinkedInAnnotationInputElement
 */
export const insertLinkedInMention = (
  editor: BufferEditor,
  data: WithPosition<LinkedInAnnotationEntityDetails>,
): Range | undefined => {
  const { start, length, ...mention } = data
  const anchor = findCharacterLimitPoint(editor, start)
  const focus =
    anchor &&
    getPointAfter(editor, anchor, {
      distance: length,
    })

  if (!anchor || !focus) {
    return
  }

  const { localizedName } = mention

  // Only insert mention if text at saved indices matches expected mention text
  // NOTE - This will result in the mention not being picked up at save time
  // so it will essentially be forgotten.
  // Slack conversation: https://buffer.slack.com/archives/C05N3DJ5K7G/p1712242666626179
  const textAtIndices = getEditorString(editor, { anchor, focus })

  if (textAtIndices === localizedName) {
    const element = LinkedInAnnotationInputElement.new('', mention)

    withoutLosingSelection(editor, () => {
      wrapNodes(editor, element, {
        at: { anchor, focus },
        split: true,
      })
    })
  }
}
